var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("img", {
      staticClass: "img-fluid mb-4 rounded",
      attrs: { src: "/media/header/locker-room.jpg", alt: "Locker Room" }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "row mb-4" }, [
      _c("div", { staticClass: "col-12" }, [
        _c(
          "nav",
          { staticClass: "nav nav-pills nav-justified oswald" },
          _vm._l(_vm.links, function(link) {
            return _c(
              "router-link",
              {
                key: link.title,
                staticClass: "nav-item nav-link ml-1 mr-1 shadow-sm",
                class: {
                  active: _vm.isActive(link),
                  "bg-white text-primary": !_vm.isActive(link),
                  "text-primary": !_vm.isActive(link),
                  "text-white": _vm.isActive(link)
                },
                attrs: { tag: "a", to: link.route, href: "#" }
              },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(link.title) +
                    "\n                    "
                )
              ]
            )
          }),
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mb-4" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c(
            "transition",
            { attrs: { name: "component-fade", mode: "out-in" } },
            [_c("router-view")],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }